/**
 * Application Constants
 * Centralized place for version numbers and asset versioning.
 *
 * HOW TO UPDATE IMAGES:
 * =====================
 * 1. Replace the file in /public/ (keep the same filename)
 * 2. Increment the corresponding version number below (e.g., '1.0.0' -> '1.0.1')
 * 3. Rebuild and redeploy the site
 *
 * The version query parameter (?v=1.0.1) forces browsers to fetch the new asset
 * instead of using their cached version.
 */

// Persistent installer download link. This S3 key is overwritten in place on
// every release (build.py --publish-download), so the URL itself never changes
// between versions — safe to hard-link from any "Download" CTA.
export const DOWNLOAD_URL =
  'https://solidly-meet-app.s3.us-east-1.amazonaws.com/releases/download/Solidly-Meet-Setup.exe';

// Support / refunds mailbox — referenced in the FAQ, footer, checkout banners,
// and the privacy/terms pages. Keep it in one place so it can't drift.
export const SUPPORT_EMAIL = 'support@solidly.ai';

// Asset versions for cache busting
export const ASSET_VERSIONS = {
  HERO_IMAGE: '1.0.0', // Main hero screenshot on homepage
  OG_IMAGE: '1.0.0', // Open Graph image for social sharing
  TWITTER_IMAGE: '1.0.0', // Twitter card image
  DEMO_VIDEO: '1.0.6', // Demo/walkthrough video (auto-bumped by video-pipeline/stage.py)
};

// Helper function to get versioned asset URL
export const getVersionedAsset = (path, version = null) => {
  if (version) {
    return `${path}?v=${version}`;
  }
  return path;
};
